import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CommonProductRoutingModule } from './common-product-routing.module';
import { CommonProductComponent } from './common-product.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DirectiveModule } from '../directive/directive.module';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import { RestrictionPopUpModule } from '../restriction-pop-up/restriction-pop-up.module';
import { SafepipeModule } from '../safepipe/safepipe.module';
import { SharedModule } from '../shared.module';
import { AddEditcommonProductComponent } from './add-editcommon-product/add-editcommon-product.component';
import { LeadImportComponent } from './lead-import/lead-import.component';
import { TransferLeadModule } from '../transfer-lead/transfer-lead.module';
import { IconModule } from '@visurel/iconify-angular';
import { PopupLeadstatusModule } from './popup-leadstatus/popup-leadstatus.module';
import { MatNativeDateModule } from '@angular/material/core';
import { CrmdealskanbanModule } from 'src/app/pages/crm/crmdealskanban/crmdealskanban.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ColumnVisibilityComponent } from './column-visibility/column-visibility.component';
import { LoaderModule } from 'src/app/pages/loader/loader.module';
import { SimpleDynamicComponentModule } from '../simple-form/simple-dynamic-component.module';
import { LeadNewPopupComponentComponent } from './lead-new-popup-component/lead-new-popup-component.component';
import { LeadDynamicFormComponent } from './lead-dynamic-form/lead-dynamic-form.component';
import { SelectLeadFormComponent } from './lead-dynamic-form/select-lead-form/select-lead-form.component';
import { XlMapperModule } from 'src/app/pages/xl-mapper/xl-mapper.module';
import { CommonGridComponent } from './common-grid/common-grid.component';
import { LeadDynamicXlComponent } from './lead-dynamic-xl/lead-dynamic-xl.component';
import { AdvanceFilterComponent } from './advance-filter/advance-filter.component';
import { DatabaseRuleComponentAdvancedComponent } from './advance-filter/database-rule-component-advanced/database-rule-component-advanced.component';
import { DatabaseRuleConditionAdvancedComponent } from './advance-filter/database-rule-condition-advanced/database-rule-condition-advanced.component';
import { DatabaseRuleActionComponentAdvancedComponent } from './advance-filter/database-rule-action-component-advanced/database-rule-action-component-advanced.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ModuleNameModule } from '../module-name-pipe/modulename.module';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
import { CrmSearchModule } from '../crm-search/crm-search.module';
import { TrialExipedMessageModule } from '../trial-exiped-message/trial-exiped-message.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { SuccessFalureModule } from '../success-falure/success-falure.module';
import { LeadDetailPanelModule } from 'src/app/pages/crm/lead-detail-panel/lead-detail-panel.module';
import { LeadOwnerSearchModule } from '../lead-owner-search/lead-owner-search.module';


@NgModule({
  declarations: [
    CommonProductComponent,
    AddEditcommonProductComponent,
    LeadImportComponent,
    ColumnVisibilityComponent,
    LeadNewPopupComponentComponent,
    LeadDynamicFormComponent,
    SelectLeadFormComponent,
    CommonGridComponent,
    LeadDynamicXlComponent,
    AdvanceFilterComponent,
    DatabaseRuleComponentAdvancedComponent,
    DatabaseRuleConditionAdvancedComponent,
    DatabaseRuleActionComponentAdvancedComponent,
    InlineEditComponent
  ],
  imports: [
    IconModule,
    MatTooltipModule,
    CommonModule,
    CommonProductRoutingModule,
    SimpleDynamicComponentModule,
    DynamicFormModule,
    MatCheckboxModule,
    SharedModule,
    DirectiveModule,
    MatDialogModule,
    FileUploadModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatChipsModule,
    SafepipeModule,
    RestrictionPopUpModule,
    TransferLeadModule,
    PerfectScrollbarModule,
    PopupLeadstatusModule,
    CrmdealskanbanModule,
    LoaderModule,
    XlMapperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatAutocompleteModule,
    ModuleNameModule,
    CrmSearchModule,
    TrialExipedMessageModule,
    MatIconModule,
    MatDividerModule,
    SuccessFalureModule,
    LeadDetailPanelModule,
    LeadOwnerSearchModule



  ], exports: [
    CommonProductComponent,
    AddEditcommonProductComponent,
    LeadImportComponent,
    ColumnVisibilityComponent,
    LeadNewPopupComponentComponent,
    SelectLeadFormComponent,
    CommonGridComponent,


  ],
})
export class CommonProductModule { }
